import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacultyRoleModel } from '../../shared/models/data/faculty-role-model';
import { AuthService } from '@shared/services/auth.service';
import { FormValidationService } from '@shared/services/form-validation.service';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';
import { FacultyModel } from '../../shared/models/data/faculty-model';
import { FacultySearchModel } from '../../shared/models/data/faculty-search-model';

@Component({
  selector: 'aaos-new-faculty-dialog',
  templateUrl: './new-faculty-dialog.component.html',
  styleUrls: ['./new-faculty-dialog.component.scss']
})
export class NewFacultyDialogComponent implements OnInit {

  formGroup: FormGroup;
  firstNameControl = 'firstName';
  lastNameControl = 'lastName';
  emailControl = 'email';
  confirmEmailControl = 'confirmEmail';
  institutionalEmailControl = 'institutionalEmail';
  roleCodeControl = 'roleCode';
  errors: string[];
  loading = false;
  facultyRoleValues: FacultyRoleModel[];
  editPrivileges = false;
  facultyToAdd: FacultyModel;
  contactNumber = '';

  constructor(private enrollmentService: EnrollmentService, private authService: AuthService, private sessionService: SessionService,
              public newFacultyDialogRef: MatDialogRef<NewFacultyDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public facultyFromSearch: FacultySearchModel) {
                newFacultyDialogRef.addPanelClass('double-column-dialog'); }

  ngOnInit(): void {
    this.loading = true;
    this.facultyRoleValues = new Array<FacultyRoleModel>();
    this.facultyRoleValues.push({facultyRoleCode: 'CHIEFRESIDENT', facultyRoleDescription: 'Chief Resident'});
    this.facultyRoleValues.push({facultyRoleCode: 'PROGRAMFACULTY', facultyRoleDescription: 'Program Faculty'});
    this.createFormGroup();

    if (this.facultyFromSearch != null) {
        this.contactNumber = this.facultyFromSearch.contactNumber;
        this.formGroup.controls[this.firstNameControl].setValue(this.facultyFromSearch.firstName);
        this.formGroup.controls[this.lastNameControl].setValue(this.facultyFromSearch.lastName);
        this.formGroup.controls[this.emailControl].setValue(this.facultyFromSearch.emailAddress);
        this.formGroup.controls[this.institutionalEmailControl].setValue(this.facultyFromSearch.institutionEmailAddress);
    }

    this.editPrivileges = this.authService.changeAuthorized();
    this.loading = false;
  }

  closeDialog() {
    this.newFacultyDialogRef.close();
  }

  invalidRequiredField(fieldName: string): boolean {
        if (this.formGroup.get(fieldName).hasError('required')) {
            return true;
        }
        return false;
  }

  createFormGroup() {
    this.formGroup = new FormGroup({
       firstName: new FormControl({value: '', disabled: this.facultyFromSearch.firstName}, [Validators.required]),
       lastName: new FormControl({value: '', disabled: this.facultyFromSearch.lastName}, [Validators.required]),
       email: new FormControl({value: '', disabled: this.facultyFromSearch.emailAddress}, [Validators.required, Validators.email]),
       confirmEmail: new FormControl({value: '', disabled: this.facultyFromSearch.emailAddress}, [Validators.required, Validators.email]),
       institutionalEmail: new FormControl({value: '', disabled: false}, [Validators.email]),
       roleCode: new FormControl({value: '', disabled: false}, [Validators.required])
    });

    this.formGroup.setValidators(FormValidationService.getControlEmailValidator(this.formGroup.controls['email'], this.formGroup.controls['confirmEmail']));
  }

  public canAddFaculty(): boolean {
    return this.formGroup.valid && this.editPrivileges;
  }

  onSubmit() {
    this.loading = true;
    this.facultyToAdd = {
      contactNumber: this.contactNumber,
      institutionAccountNumber: this.sessionService.getInstitutionId(),
      webRoleCode: this.formGroup.controls[this.roleCodeControl].value,
      contactWebRoleId: '',
      firstName: this.formGroup.controls[this.firstNameControl].value,
      lastName: this.formGroup.controls[this.lastNameControl].value,
      emailAddress: this.formGroup.controls[this.emailControl].value,
      institutionalEmail: this.formGroup.controls[this.institutionalEmailControl].value,
    };

    this.enrollmentService.saveFaculty(this.facultyToAdd).subscribe(resp => {
      this.loading = false;

      this.errors = new Array<string>();

      if (resp.isValid) {
        this.newFacultyDialogRef.close();
      } else {
        this.errors = resp.errors;
      }
    });
  }

}
